import dynamic from 'next/dynamic';
import classNames from 'classnames';
import styles from './icon-custom.module.scss';
export type TIconId = 'ArrowBackCurved' | 'ArrowRight' | 'ArrowThinLeft' | 'Book' | 'Calendar' | 'Card' | 'Cards' | 'CardsFilled' | 'CardsOpen' | 'Cart' | 'CartAdd' | 'CartFilled' | 'Cash' | 'CheckMark' | 'CheckMarkThin' | 'ChevronDown' | 'ChevronLeft' | 'ChevronRight' | 'ChevronUp' | 'Clock' | 'Close' | 'Company' | 'CompanyFilled' | 'Edit' | 'EngbersGermanyLogoFlag' | 'EyeClose' | 'EyeOpen' | 'Filter' | 'Heart' | 'HeartFilled' | 'Headphone' | 'Home' | 'Inbox' | 'InboxClosed' | 'Info' | 'Lock' | 'LockOpen' | 'Logo' | 'MapMarker' | 'MapMarkerFat' | 'MapMarkerFilled' | 'MapMarkerPwa' | 'MapMarkerThin' | 'Menu' | 'Newsletter' | 'Phone' | 'PinchClose' | 'PinchHand' | 'PinchMagnifier' | 'Print' | 'Search' | 'Shirt' | 'ShoppingBag' | 'SizeInfo' | 'Store' | 'TrashBasket' | 'Trust' | 'User' | 'UserAdd' | 'UserCrown' | 'UserFilled';
export interface IIconCustom {
  icon: TIconId;
  color?: 'white' | 'primary' | 'darkBlue' | 'green-neon' | 'custom' | 'green' | 'danger';
  width?: number;
  className?: string;
  customColor?: string;
}
export const IconCustom: React.FC<IIconCustom> = ({
  icon,
  color,
  width = 32,
  className,
  customColor
}) => {
  const IconComponent = dynamic(() => import(`./assets/${icon}`).then(module => module[`${icon}Icon`]), {
    ssr: false
  });
  if (!IconComponent) {
    return null;
  }
  return <div className={classNames(styles.iconWrap, {
    [styles[`iconWrap--color-${color}`]]: color
  }, className)} style={{
    width: width,
    color: customColor
  }} data-sentry-component="IconCustom" data-sentry-source-file="index.tsx">
      <IconComponent data-sentry-element="IconComponent" data-sentry-source-file="index.tsx" />
    </div>;
};